// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import datatable from '../datatable'
import assetOperations$ from '../selectors/operations'
import fieldBorderOperations$ from '../selectors/uploadOperations'
import category$ from '../selectors/category'
import farmSelectorOptions$ from '../selectors/farmSelectorOptions'
import seasonSpecificFields$ from '../selectors/seasonSpecificFields'
import assets$ from '../selectors/assets'
import { seasonSelectorOptions$, selectedSeasonId$, updateCurrentSeason } from 'hfty-seasons'
import { firstAvailableGrowerId$ } from 'fc-assets'
import { selectedFarmId$ } from 'hfty-assets'
import { jobs$ } from 'hfty-soil-jobs'

// Operator
import assetsOperator from 'hfty-operator-asset'
import fieldBordersOperator from 'fc-operator-fieldborder'

// Action Creator
import { addAsset, deleteAssets, editAssets, zoomOnMap } from '../actions'
import { assetMigrateActions } from 'hfty-asset-migrate-dom'
import { uploadFieldBorders, updateFieldBorderOperation } from 'fc-upload-borders'

import { push } from 'react-router-redux'

// State -> Props
type Props = {
  selectedIds: Array<number>
}

function mapStateToProps (state: Object): Props {
  return {
    selectedIds: datatable.selectors.selectedRecordIds$(state),
    operations: assetOperations$(state),
    uploadOperations: fieldBorderOperations$(state),
    category: category$(state),
    farmSelectorOptions: farmSelectorOptions$(state),
    seasonSelectorOptions: seasonSelectorOptions$(state),
    selectedSeasonId: selectedSeasonId$(state),
    seasonSpecificFields: seasonSpecificFields$(state),
    growerId: firstAvailableGrowerId$(state),
    assets: assets$(state),
    selectedFarmId: selectedFarmId$(state),
    jobs: jobs$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onEdit: Function,
    onDelete: Function,
    onUpload: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators(
      {
        onAdd: addAsset,
        onEdit: editAssets,
        onDelete: deleteAssets,
        onMigrate: assetMigrateActions.migrateAsset,
        onUpload: uploadFieldBorders,
        onChangeSeason: updateCurrentSeason,
        onChangeOperation: assetsOperator.actionCreators.updateOperation,
        onCancelOperations: assetsOperator.actionCreators.cancelOperations,
        onSubmitOperations: assetsOperator.actionCreators.submitOperations,
        updateFieldBorderOperation: updateFieldBorderOperation,
        onCancelUploadOperations: fieldBordersOperator.actionCreators.cancelOperations,
        onSubmitUploadOperations: fieldBordersOperator.actionCreators.submitOperations,
        push,
      },
      dispatch
    ),
    onMapToAsset: zoomOnMap(dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
